import React from 'react'

export default function SupportLink({ link }) {
  return (
    <div className='d-flex justify-content-end p-2' style={{ fontFamily: "DM Sans" }}>
      <a style={{ fontSize: '12px', color: '#2c40ce' }} target='__blank' href={link}>Support Document</a>
    </div>
  )
}
